// modules/orders/reducers
import { Map, fromJS } from 'immutable'

import { strings } from 'context/LanguageContext/strings'
import { actions as authAction } from 'modules/authentication/actions'
import { actions as basketActions } from 'modules/basket/actions'
import { actions } from 'modules/orders/actions'

const getInitialState = () =>
    Map({
        gettingCurrentOrders: false,
        gettingPastOrders: false,
        // TO DO: Clean up the reducer, parse and save the response
        // currentOrders: List([]), pastOrders: List([])
        currentOrders: [],
        pastOrders: {
            orders: [],
            lastIndex: 0,
        },
        currentOrder: {
            id: null,
            order: null,
            polling: false,
            delivery: null,
        },
        gettingLastCurrentOrders: false,
        gettingLastPastOrders: false,
        lastCurrentOrders: {
            orders: [],
            lastIndex: 0,
            totalCount: 0,
        },
        lastPastOrders: {
            orders: [],
            lastIndex: 0,
        },
        orderStatus: null,
        submittingFeedback: false,
        feedbackSubmitted: false,
        rating: 0,
        labelText: strings.tellUsAboutYourExperience,
        comment: '',
        feedback_orderId: null,
        activeOrdersCount: 0,
        currentStatus: '',
        orderItems: null,
        gettingOrderItems: false,
        orderPlaced: false,
        showReOrderErrorMsg: false,
        isReOrder: false,
    })

const final_statuses = ['delivered', 'canceled', 'failed']

export default (state = getInitialState(), action) => {
    const { type, payload } = action

    switch (type) {
        case actions.DISPLAY_FEEDBACK_MODAL: {
            return state.merge({
                feedback_orderId: payload,
            })
        }

        case actions.GET_CURRENT_ORDERS_LIST: {
            return state.merge({
                gettingCurrentOrders: true,
            })
        }

        case actions.GET_CURRENT_ORDERS_LIST_SUCCESS: {
            return state.merge({
                currentOrders: payload.orders,
                gettingCurrentOrders: false,
                activeOrdersCount: payload && payload.orders ? payload.orders.length : 0,
            })
        }

        case actions.SET_ACTIVE_ORDERS_COUNT: {
            return state.merge({
                activeOrdersCount: fromJS(payload),
            })
        }

        case actions.GET_CURRENT_ORDERS_LIST_FAILED: {
            return state.set('gettingCurrentOrders', false)
        }

        case actions.GET_PAST_ORDERS_LIST: {
            const pastOrders = state.get('pastOrders')
            const next = payload

            return state.merge({
                pastOrders: {
                    ...pastOrders,
                    orders: next ? pastOrders.orders : [],
                },
                gettingPastOrders: true,
            })
        }

        case actions.GET_PAST_ORDERS_LIST_SUCCESS: {
            const { orders } = state.get('pastOrders')
            const last = payload.LastEvaluatedKey

            return state.merge({
                pastOrders: {
                    orders: payload.next ? [...orders, ...payload.orders] : payload.orders,
                    lastIndex: last ? last.id : 0,
                },
                gettingPastOrders: false,
            })
        }

        case actions.GET_PAST_ORDERS_LIST_FAILED: {
            return state.set('gettingPastOrders', false)
        }

        case actions.SET_COMMENT: {
            return state.set('comment', payload)
        }

        case actions.SET_RATING: {
            return state.merge({
                labelText:
                    payload === 1 ? strings.tellUsWhatWentWrong : strings.tellUsAboutYourExperience,
                rating: payload,
            })
            // return state.set('rating', payload)
        }

        case actions.SUBMIT_FEEDBACK: {
            return state.merge({
                submittingFeedback: true,
                feedbackSubmitted: false,
            })
        }

        case actions.SUBMIT_FEEDBACK_SUCCESS: {
            return state.merge({
                feedback_orderId: null,
                comment: '',
                rating: 0,
                submittingFeedback: false,
                feedbackSubmitted: true,
                labelText: strings.tellUsAboutYourExperience,
            })
        }

        case actions.SUBMIT_FEEDBACK_FAILED: {
            return state.merge({
                submittingFeedback: false,
                comment: '',
                rating: 0,
                labelText: strings.tellUsAboutYourExperience,
            })
        }

        // Order Status
        case actions.START_POLLING_ORDER_STATUS: {
            const orderId = payload
            return state.set('currentOrder', {
                ...state.get('currentOrder'),
                polling: true,
                id: orderId,
                delivery: null,
            })
        }

        case actions.STOP_POLLING_ORDER_STATUS: {
            // Stop polling
            return state.set('currentOrder', {
                ...state.get('currentOrder'),
                polling: false,
                delivery: null,
                id: null,
                order: null,
            })
        }

        case actions.GET_ORDER_STATUS_SUCCESS: {
            // stop polling if last_status reached any of the final_statuses
            const history = payload.order_history || []
            const lastEvent = history[history.length - 1] || {}
            const status = lastEvent.order_status

            // Update Current orders
            // Once the order reaches a final status, the saga will reload all orders
            let orders = state.get('currentOrders') || []
            if (!final_statuses.includes(status)) {
                // update "current orders" item
                orders = orders.map(o => (o.order_id === payload.order_id ? payload : o))
            }

            return state.merge({
                currentOrders: orders,
                currentOrder: {
                    ...state.get('currentOrder'),
                    order: payload,
                    id: payload && payload.order_id,
                },
                feedbackSubmitted: !!payload.customer_feedback,
                orderPlaced: false,
            })
        }

        case actions.GET_ORDER_STATUS_FAILED: {
            return state
        }

        case actions.REMOVE_CURRENT_ORDER: {
            return state.merge({
                currentOrder: {
                    id: null,
                    order: null,
                    polling: false,
                    delivery: null,
                },
            })
        }

        // Order Delivery
        case actions.GET_ORDER_DELIVERY_SUCCESS: {
            return state.merge({
                currentOrder: {
                    ...state.get('currentOrder'),
                    delivery: payload,
                },
                feedbackSubmitted: !!payload.customer_feedback,
            })
        }

        case actions.GET_ORDER_DELIVERY_FAILED: {
            return state
        }

        // On Logout, clear orders
        case authAction.SIGN_OUT_SUCCESS: {
            return getInitialState()
        }

        case actions.SET_CURRENT_ORDER_STATUS: {
            return state.merge({
                currentStatus: payload,
            })
        }

        case actions.GET_LAST_CURRENT_ORDERS_LIST: {
            const lastCurrentOrders = state.get('lastCurrentOrders')
            const next = payload

            return state.merge({
                lastCurrentOrders: {
                    ...lastCurrentOrders,
                    orders: next ? lastCurrentOrders.orders : [],
                },
                gettingLastCurrentOrders: true,
            })
        }

        case actions.GET_LAST_CURRENT_ORDERS_LIST_SUCCESS: {
            const { orders } = state.get('lastCurrentOrders')
            const last = payload.LastEvaluatedKey

            return state.merge({
                lastCurrentOrders: {
                    orders: payload.next ? [...orders, ...payload.orders] : payload.orders,
                    lastIndex: last ? last.id : 0,
                    totalCount: payload.inProgressOrdersCount,
                },
                gettingLastCurrentOrders: false,
            })
        }

        case actions.GET_LAST_CURRENT_ORDERS_LIST_FAILED: {
            return state.set('gettingLastCurrentOrders', false)
        }

        case actions.GET_LAST_PAST_ORDERS_LIST: {
            const lastPastOrders = state.get('lastPastOrders')
            const next = payload

            return state.merge({
                lastPastOrders: {
                    ...lastPastOrders,
                    orders: next ? lastPastOrders.orders : [],
                },
                gettingLastPastOrders: true,
            })
        }

        case actions.GET_LAST_PAST_ORDERS_LIST_SUCCESS: {
            const { orders } = state.get('lastPastOrders')
            const last = payload.LastEvaluatedKey

            return state.merge({
                lastPastOrders: {
                    orders: payload.next ? [...orders, ...payload.orders] : payload.orders,
                    lastIndex: last ? last.id : 0,
                },
                gettingLastPastOrders: false,
            })
        }

        case actions.GET_LAST_PAST_ORDERS_LIST_FAILED: {
            return state.set('gettingLastPastOrders', false)
        }

        case actions.GET_ORDER_DETAILS: {
            return state.merge({
                gettingOrderDetail: true,
            })
        }
        case actions.GET_ORDER_DETAILS_SUCCESS: {
            return state.merge({
                orderItems: payload?.items,
                gettingOrderItems: false,
            })
        }
        case actions.GET_ORDER_DETAILS_FAILED: {
            return state.merge({
                gettingOrderDetail: false,
            })
        }
        case basketActions.PLACE_ORDER_SUCCESS: {
            return state.merge({
                orderPlaced: true,
            })
        }

        case actions.SHOW_REORDER_ERROR_MSG: {
            return state.merge({
                showReOrderErrorMsg: payload
            })
        }

        case actions.SET_IS_REORDER: {
            return state.merge({
                isReOrder: payload
            })
        }

        default:
            return state
    }
}

export const parseOrder = rawOrder => {
    const order = {
        order_status: '',
        order_type: '',
        order_id: '',
        created: null,
        created_time: null,
        user_profile: {},
        shipping: {},
        payment: {},
        total: {},
        customer_feedback: null,
        items: [],
        summary: {},
    }

    if (rawOrder.order_id) order.order_id = rawOrder.order_id

    if (rawOrder.order_type) order.order_type = rawOrder.order_type

    if (rawOrder.order_status) order.order_status = rawOrder.order_status

    if (rawOrder.created) order.created = rawOrder.created

    if (rawOrder.created_time) order.created_time = rawOrder.created_time

    if (rawOrder.user_profile) order.user_profile = rawOrder.user_profile

    if (rawOrder.shipping && rawOrder.shipping.delivery_details)
        order.delivery_details = rawOrder.shipping.delivery_details

    if (rawOrder.payment) order.payment = rawOrder.payment

    if (rawOrder.original_total_including_tip) order.total = rawOrder.original_total_including_tip

    if (rawOrder.items) order.items = rawOrder.items

    if (rawOrder.summary) order.summary = rawOrder.summary

    if (rawOrder.customer_feedback) order.customer_feedback = rawOrder.customer_feedback

    return order
}
